import FetchService from '../../../core/services/FetchService';
import { action, extendObservable } from 'mobx';

class SystemTranslationLabelStatisticService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      summary: 0,
    });
  }

  load = action(() => {
    this.fetch
      .fetch({
        url: '/localization-items/total',
      })
      .then(() => {
        if (this.fetch.data) {
          this.summary = this.fetch.data.total;
        }
        if (this.fetch.error) {
          this.summary = 0;
        }
      });
  });
}

export default SystemTranslationLabelStatisticService;
